import {
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Autocomplete,
  Row,
  Col,
  // Badge,
  Input,
  // Dropdown,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Image,
  Switch,
  Card,
  Form,
  FormItem,
  DatePicker,
  Badge,
  Timeline,
  TimelineItem,
  // StatsCard,
  // Navbar,
  // NavbarToggleButton,
  // Switch,
  // InfoSection,
  Collapse,
  CollapseItem,
  Popover,
  Select,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  Dialog,
  MessageBox,
  Message,
  Notification,
  Tabs,
  TabPane,
  Loading,
  Drawer,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const GlobalComponents = {
  install(Vue) {
    Vue.use(Menu);
    Vue.use(Submenu);
    Vue.use(MenuItem);
    Vue.use(MenuItemGroup);
    Vue.use(Autocomplete);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Popover);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(OptionGroup);
    Vue.use(Button);
    Vue.use(ButtonGroup);
    Vue.use(Image);
    Vue.use(Switch);
    Vue.use(Card);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(DatePicker);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.use(Input);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(RadioButton);
    Vue.use(Checkbox);
    Vue.use(CheckboxButton);
    Vue.use(CheckboxGroup);
    Vue.use(Timeline);
    Vue.use(TimelineItem);
    Vue.use(Drawer);

    Vue.component(Badge.name, Badge);
    // Vue.component(Badge.name, Badge);
    // Vue.component(Input.name, Input);
    // Vue.component(Dropdown.name, Dropdown);
    // Vue.component(Checkbox.name, Checkbox);
    // Vue.component(Button.name, Button);
    // Vue.component(Card.name, Card);
    // Vue.component(StatsCard.name, StatsCard);
    // Vue.component(Navbar.name, Navbar);
    // Vue.component(NavbarToggleButton.name, NavbarToggleButton);
    // Vue.component(Switch.name, Switch);
    // Vue.component(InfoSection.name, InfoSection);
    Vue.use(Dialog);
    Vue.use(Loading.directive);
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$message = Message;
  },
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/globalComponents.js